import axios from "./axiosInstance";
import CryptoUtils from "../util/cryptoUtils";
export const createBriefAPI = async (postData) => {
  
  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };

  const endpoint = "/Brief/CreateBrief?roleId="+ CryptoUtils.getFromLocalStorage("roleId");
  const apiResponse = await axios.post(endpoint, postData, config);
  return apiResponse;
};

export const updateBriefAPI = async (postData) => {
  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };

  const endpoint = "/Brief/UpdateBrief?roleId="+CryptoUtils.getFromLocalStorage("roleId");
  const apiResponse = await axios.post(endpoint, postData, config);
  return apiResponse;
}

export const deleteBriefById = async (id) =>{
  const endpoint = `Brief/DeleteBriefByBriefId?proposalId=${id}`;
  const apiResponse = await axios.delete(endpoint);
  return apiResponse;
}

export const getBriefByID = async (id) =>{
  const endpoint = `/Brief/GetBriefByBriefId?proposalId=${id}`;
  const apiResponse = await axios.get(endpoint);
  return apiResponse;
}

export const getAllCriteria = async () => {
  const endpoint = "/common/Criteria/GetAllCriteria";
  const apiResponse = await axios.get(endpoint);
  return apiResponse;
};
